export const FAQ_CATEGORIAS = [
  { id: 1, label: "SOBRE O PROGRAMA" },
  { id: 2, label: "RESGATES" },
  { id: 3, label: "PONTUAÇÃO" },
  { id: 4, label: "EXTRATO" },
];

export function agruparPorCategoria(faqs) {
  if (!Array.isArray(faqs)) return [];
  return FAQ_CATEGORIAS
    .map((cat) => ({
      ...cat,
      items: faqs.filter((f) => f.categoria === cat.id),
    }))
    .filter((cat) => cat.items.length > 0);
}
